import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyBOxZyA03hSJu545xmcgl3cujGaw2Ylu00",
    authDomain: "kasakai-intranet-tools.firebaseapp.com",
    projectId: "kasakai-intranet-tools",
    storageBucket: "kasakai-intranet-tools.firebasestorage.app",
    messagingSenderId: "461701591911",
    appId: "1:461701591911:web:415978f32360cef0c9f5c2"
};

// Initialize Firebase
if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}

export const auth = firebase.auth();
export const db = firebase.firestore();
export const googleProvider = new firebase.auth.GoogleAuthProvider();

// Use config for admin email - allows environment variable override
import { APP_CONFIG } from './config';
export const ADMIN_EMAIL = APP_CONFIG.ADMIN_EMAIL;
